import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { FormFieldsContainer, FormFieldsDeadline } from '../../../Form'
import { NotificationInline } from '../../../Notification'
import { TASK_FORM_DEADLINE_FIELD_NAME } from '../../../Task'
import { QA_NAME_CALENDAR_TASK_MOVE_PROCESS_NOTICE } from '../CalendarTaskMoveModal.constants'

import { DayLoadNotice } from './DayLoadNotice'
import { PreviousDeadline } from './PreviousDeadline'
import { TaskSummary } from './TaskSummary'

function CalendarTaskMoveModalFields({ dayLoad, isFailed, item }) {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <TaskSummary item={item} />
      <PreviousDeadline deadline={item.deadline} />
      <FormFieldsDeadline
        deadlineFieldName={TASK_FORM_DEADLINE_FIELD_NAME}
        inputDateLabel='Calendar.MoveDueNewKey'
        inputDatePlaceholder='Common.DatePickerAddDateKey'
        inputTimeLabel='Common.DatePickerTimeKey'
        inputTimePlaceholder='Common.DatePickerAddTimeKey'
      />
      <DayLoadNotice dayLoad={dayLoad} isFailed={isFailed} />
      <NotificationInline
        qaName={QA_NAME_CALENDAR_TASK_MOVE_PROCESS_NOTICE}
        text={t('Calendar.MoveTaskProcessNoticeKey')}
        type={NOTIFICATION_TYPE.info}
      />
    </FormFieldsContainer>
  )
}

export default CalendarTaskMoveModalFields
